<template>
  <component
    :is="isTruncated ? BittsTooltip : 'div'"
    v-bind="tooltipProps"
    class="min-w-0"
  >
    <span ref="textElement" :class="contentClasses">{{ text }}</span>
    <template v-if="isTruncated" #title>
      <span :class="maskClasses">{{ text }}</span>
    </template>
  </component>
</template>

<script setup lang="ts">
import { BittsTooltip } from '@crossbeam/bitts';

import { computed, ref, watch } from 'vue';

import { useIsTruncated } from '@/composables/useIsTruncated';

const {
  text,
  isMasked = false,
  isMountedToBody = false,
} = defineProps<{
  text: string;
  isMasked?: boolean;
  isMountedToBody?: boolean;
}>();

const maskClasses = computed(() =>
  isMasked ? 'ph-no-capture dd-privacy-mask' : '',
);

const contentClasses = computed(() => [
  'irp-field-grid-text__content',
  maskClasses.value,
]);

const textElement = ref<HTMLElement | null>(null);
const { isTruncated, checkTruncation } = useIsTruncated(textElement);

const tooltipProps = computed(() =>
  isTruncated.value ? { mountToBody: isMountedToBody } : {},
);

watch(() => text, checkTruncation, { flush: 'post' });
</script>

<style lang="pcss" scoped>
@reference "../../../css/theme.css";
.irp-field-grid-text__content {
  @apply block truncate;
}
</style>
